import angular from 'angular';

import component from './phone-filter-view.component';

const PhoneFilterView = angular
    .module('control-room.commons.content.components.phone-filter-view', [])
    .component('crPhoneFilterView', component);

export default PhoneFilterView;
